import { render, staticRenderFns } from "./recruit-links.vue?vue&type=template&id=701d1bcd&scoped=true"
import script from "./recruit-links.vue?vue&type=script&lang=js"
export * from "./recruit-links.vue?vue&type=script&lang=js"
import style0 from "./recruit-links.vue?vue&type=style&index=0&id=701d1bcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701d1bcd",
  null
  
)

export default component.exports